export const toCamelCase = (str: string): string => {
  return str.replace(/_([a-z0-9])/g, (_, char) => char.toUpperCase())
}

export const toCamelCaseKeys = <T>(value: T): T => {
  if (Array.isArray(value)) {
    return value.map((item) => toCamelCaseKeys(item)) as unknown as T
  }

  if (value && typeof value === 'object') {
    if (value instanceof Date) {
      return value
    }

    const obj = value as Record<string, unknown>
    const result: Record<string, unknown> = {}

    Object.keys(obj).forEach((key) => {
      const newKey = toCamelCase(key)
      result[newKey] = toCamelCaseKeys(obj[key] as unknown)
    })

    return result as T
  }

  return value
}

export const toSnakeCase = (str: string): string => {
  return str
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/\s+/g, '_')
    .toLowerCase()
}

export const toSnakeCaseKeys = <T>(value: T): T => {
  if (Array.isArray(value)) {
    return value.map((item) => toSnakeCaseKeys(item)) as unknown as T
  }

  if (value && typeof value === 'object') {
    // Handle Date
    if (value instanceof Date) {
      return value
    }

    const obj = value as Record<string, unknown>
    const result: Record<string, unknown> = {}

    Object.keys(obj).forEach((key) => {
      const newKey = toSnakeCase(key)
      // Preserve nested keys for voice maps (e.g. { "vi-VN-Standard-C": "..." })
      // because converting them to snake_case would corrupt the voice identifiers.
      if (key === 'audioLinks' || key === 'audio_links') {
        result[newKey] = obj[key]
        return
      }

      result[newKey] = toSnakeCaseKeys(obj[key] as unknown)
    })

    return result as T
  }

  return value
}
